export type TrendDirection = 'up' | 'down' | 'flat';

export const TREND_ICON: Record<TrendDirection, string> = { up: '▲', down: '▼', flat: '—' };
export const TREND_COLOR: Record<TrendDirection, string> = {
  up: 'text-green-400',
  down: 'text-red-400',
  flat: 'text-text-tertiary',
};
